import React from 'react';
import { Field, reduxForm, FieldArray, formValueSelector } from 'redux-form';
import { useIntl, FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import Button from 'react-bootstrap/lib/Button';

import submit from './submit';
import validate from './validate';
import FieldArrayComponent from '../../../CommonFields/FieldArrayComponent';
import { useSelector } from 'react-redux';

import cs from '../../../../components/commonStyle.css';
import s from '../../../../components/siteadmin/admin-common.css';
import messages from '../../../../locale/jsonMessages';

const ReportTypeForm = (props) => {
    const { formatMessage } = useIntl();
    const { handleSubmit, error } = props;
    const selectedLanguage = useSelector(state => selector(state, 'dynamicReportType'));

    return (
        <div className='siteAdminCenterContainer siteAdminCenterContainerBox'>
            <h1 className='siteAdminHeading'>
                <FormattedMessage  {...messages.reportTypeManagement} />
            </h1>
            <form onSubmit={handleSubmit(submit)}>
                {error && <strong>{formatMessage(error)}</strong>}
                <div>
                    {(
                        <FieldArray
                            name="dynamicReportType"
                            component={FieldArrayComponent}
                            activesFields={['language', 'reportType', 'reportContent']}
                            formName={'ReportTypeForm'}
                            filedName={"dynamicReportType"}
                            selectedLanguage={selectedLanguage}
                        />
                    )}
                </div>
                <div className={cx(cs.spaceTop4, 'singleBtnFlexEnd')}>
                    <Button type='submit' className={cx(cs.btnPrimary)}>
                        <FormattedMessage  {...messages.save} />
                    </Button>
                </div>
            </form>
        </div>
    );
}

const selector = formValueSelector('ReportTypeForm');

export default reduxForm({
    form: 'ReportTypeForm',
    validate
})(withStyles(s, cs)((ReportTypeForm)));